// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1SsTL","inputWrap":"styles_inputWrap__38Ubd","input":"styles_input__1twd8"};